import { Translation } from '@shared/types/translation';

export const CERTIFICATE_MESSAGES = {
  CERTIFICATE_SPOTLIGHT_LABEL: {
    english:
      'Your certificate is ready. Open the Certificates tab to view and download it.',
    polish:
      'Twój certyfikat jest gotowy. Otwórz zakładkę Certyfikaty, aby go wyświetlić i pobrać.',
  },
} as const satisfies Record<string, Translation>;
